exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.row[data-v-2148c25c] {\n  margin: 0 0.53333333rem;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-2148c25c&scoped=true!./~/autoprefixer-loader!./~/px2rem-loader?remUnit=37.5&remPrecision=8!./~/less-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/register.vue
// module id = 306
// module chunks = 1